// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"180":"5bde542c","248":"84bf11ad","299":"449d97aa","311":"f1c129f9","536":"b6771b55","888":"42b50a43","922":"77ec8d67"}[chunkId] + ".css";
};